import {
  Checkbox,
  InlineStack,
  Modal,
  ResourceItem,
  ResourceList,
  Text,
  Thumbnail,
} from "@shopify/polaris";

const CouponBundleModal = ({
  modalActive,
  handleModalToggle,
  bundles,
  selectedBundles,
  handleBundleSelection,
}) => {
  return (
    <>
      {modalActive && (
        <Modal
          open={modalActive}
          onClose={handleModalToggle}
          title="Select Bundles"
          primaryAction={{ content: "Done", onAction: handleModalToggle }}
        >
          <Modal.Section>
            <ResourceList
              resourceName={{ singular: "bundle", plural: "bundles" }}
              items={bundles}
              renderItem={(bundle) => {
                const { _id, name, coverImage, price } = bundle;
                const isSelected = selectedBundles.find(
                  (selected) => selected._id === bundle._id
                );

                return (
                  <ResourceItem
                    id={_id}
                    key={_id}
                    accessibilityLabel={`Select ${name}`}
                    // onClick={() => handleBundleSelection(_id)}
                  >
                    <InlineStack gap={"1000"} blockAlign="center" align="start">
                      <Checkbox
                        checked={isSelected}
                        onChange={() => handleBundleSelection(bundle)}
                      />
                      <Thumbnail size="small" source={coverImage?.url} />

                      <Text>{name}</Text>
                      <Text>₹{price}</Text>
                    </InlineStack>
                  </ResourceItem>
                );
              }}
            />
          </Modal.Section>
        </Modal>
      )}
    </>
  );
};

export default CouponBundleModal;
